module.exports = __webpack_public_path__ + "static/media/logo.f5ae473a.png";